import type { ReactNode } from 'react';
import { cn } from '../lib/utils';

export interface DashboardHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** page-level action, right-aligned beside the title */
  action?: ReactNode;
  /** parent link above the title, for detail pages */
  crumb?: ReactNode;
  className?: string;
}

/** The one page heading inside the dashboard shell: a crumb, a title beside its
 *  action, a description, and the hairline that opens the working column. No
 *  kicker, band, or illustration - the public site sets a stage, an account
 *  page does not. */
export const DashboardHeader = ({
  title,
  description,
  action,
  crumb,
  className,
}: DashboardHeaderProps) => (
  <header className={cn('border-b border-rule pb-4', className)}>
    {crumb === undefined ? null : <div className="mb-2 text-13 text-text-3">{crumb}</div>}
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-26 font-medium tracking-[-0.02em] text-text">{title}</h1>
      {action === undefined ? null : (
        <div className="flex shrink-0 items-center gap-2">{action}</div>
      )}
    </div>
    {description === undefined ? null : (
      <p className="mt-1 max-w-190 text-14 text-text-2">{description}</p>
    )}
  </header>
);
